// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { Conditional, Else, Heading, If, useSync } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { UserForm, UserFormat, useUserDetailQuery } from "@s-i-s-i/see-learning.shared";
import { Main } from "../../../../Components";
import { userHubDetailPageInfo } from "./pageinfo";

export function UserHubDetailPage() {
	const { userID } = userHubDetailPageInfo.useParams();

	const { loading, data, error } = useUserDetailQuery({ variables: { id: userID } });
	const user = data?.user;
	useActivePageRegistration(userHubDetailPageInfo, !!user ? userHubDetailPageInfo.title(user) : "");

	const { syncID, synchronize } = useSync();

	return (
		<Main>
			<Conditional>
				<If condition={loading}>Loading...</If>
				<If condition={error !== undefined}>Error loading user</If>
				<Else>
					{!!user && (
						<React.Fragment>
							<Heading.H1>{UserFormat.name(user)}</Heading.H1>

							<UserForm.ControlledDetail key={syncID} user={user} onSuccess={synchronize} />
						</React.Fragment>
					)}
				</Else>
			</Conditional>
		</Main>
	);
}
